var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMonProfile = function SvgIconMonProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-mon-profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "rgba(255,160,160,0.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3.375,
    cy: 3.375,
    r: 3.375,
    transform: "translate(5.625 3.75)",
    fill: "#f66969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M530.167 155.35a7.459 7.459 0 0 1-5.027-1.95c.634-1.469 2.639-2.55 5.027-2.55s4.393 1.081 5.027 2.55a7.459 7.459 0 0 1-5.027 1.95Z",
    transform: "translate(-521.167 -138.85)",
    fill: "rgba(246,105,105,0.75)"
  }))));
};
export { SvgIconMonProfile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1tb24tcHJvZmlsZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGcgaWQ9Imljb24iPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xNSIgZGF0YS1uYW1lPSJFbGxpcHNlIDE1IiBjeD0iOSIgY3k9IjkiIHI9IjkiIGZpbGw9InJnYmEoMjU1LDE2MCwxNjAsMC44KSIvPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xNiIgZGF0YS1uYW1lPSJFbGxpcHNlIDE2IiBjeD0iMy4zNzUiIGN5PSIzLjM3NSIgcj0iMy4zNzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNjI1IDMuNzUpIiBmaWxsPSIjZjY2OTY5Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF84NiIgZGF0YS1uYW1lPSJQYXRoIDg2IiBkPSJNNTMwLjE2NywxNTUuMzVhNy40NTksNy40NTksMCwwLDEtNS4wMjctMS45NWMuNjM0LTEuNDY5LDIuNjM5LTIuNTUsNS4wMjctMi41NXM0LjM5MywxLjA4MSw1LjAyNywyLjU1QTcuNDU5LDcuNDU5LDAsMCwxLDUzMC4xNjcsMTU1LjM1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUyMS4xNjcgLTEzOC44NSkiIGZpbGw9InJnYmEoMjQ2LDEwNSwxMDUsMC43NSkiLz4KICA8L2c+Cjwvc3ZnPgo=";